import { NgClass, NgStyle } from "@angular/common";
import { Component, Input, OnInit } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";


export class LegendRow {
    color: string;
    translationKey: string;
}

@Component({
    selector: "app-legend",
    templateUrl: "./legend.component.html",
    imports: [TranslateModule, NgStyle, NgClass],
})
export class LegendComponent implements OnInit {
    @Input() configuration: LegendRow[];
    @Input() direction: string;

    constructor() {}

    ngOnInit(): void {}
}
